import type { CSSProperties } from "react";
import { panelPalette, panelSurfaceStyle } from "./assistant-panel.tokens";

/** Ukuran & gaya tata letak panel asisten (Drawer FAB, mode tertanam, ruang di halaman). */

/** Lebar panel mode normal; halaman & /wall memberi ruang selebar ini agar kontennya tidak tertutup. */
export const ASSISTANT_PANEL_WIDTH = 440;

/** Tinggi header AppShell (MainLayout & /profile); panel yang menutupi halaman (diperbesar / di bawah md) dimulai di bawahnya. */
export const ASSISTANT_HEADER_HEIGHT = 60;

/** Radius sudut kiri panel mode normal (px); mode diperbesar (lebar penuh) tanpa radius. */
export const ASSISTANT_PANEL_RADIUS = 16;

/**
 * Gaya Drawer panel (`styles` Mantine). Hanya `content` (panel); `inner`
 * (pembungkus fixed selayar penuh) sengaja tidak diberi gaya. `topOffset`
 * menurunkan panel (0 = setinggi layar, mode normal desktop). Sudut kiri atas &
 * bawah melengkung hanya saat mode normal (`maximized` = false). Warna dari
 * token di `assistant-panel.tokens.ts`.
 */
export function assistantPanelStyles(
	dark: boolean,
	topOffset = 0,
	maximized = false,
): Record<"content", CSSProperties> {
	const radius = maximized ? 0 : ASSISTANT_PANEL_RADIUS;
	const p = panelPalette(dark);
	return {
		content: {
			...panelSurfaceStyle(dark),
			...(topOffset > 0
				? { marginTop: topOffset, height: `calc(100% - ${topOffset}px)` }
				: {}),
			display: "flex",
			flexDirection: "column",
			overflow: "hidden",
			borderTopLeftRadius: radius,
			borderBottomLeftRadius: radius,
			borderLeft: `1px solid ${p.border}`,
			// Bayangan ke arah halaman; mode diperbesar menutup halaman penuh.
			boxShadow: maximized ? "none" : p.shadow,
		},
	};
}

/** Isi panel di bawah header: mengisi sisa tinggi; pesan bergulir, composer di bawah. */
export const PANEL_BODY_STYLE: CSSProperties = {
	flex: 1,
	minHeight: 0,
	display: "flex",
	flexDirection: "column",
};
